import React from 'react'
import Header from './Header'
import { Outlet } from 'react-router-dom'
import { HeaderSubDropdown } from './HeaderSubDropdown'
import HeaderLayout from './HeaderLayout'
import HeaderLayoutWrapper from './HeaderLayoutWrapper'

export default function Layout() {
  return (
    <>
    {/* <Header /> */}
    {/* <HeaderSubDropdown /> */}
    {/* <HeaderLayout /> */}
    <HeaderLayoutWrapper />
    <Outlet />
    </>
  )
}
